<template>
    <div class="commonTableStyles materialPlan-box">
        <HeaderNav
            header-title="用料计划"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="newPlan" @click="newPlan">
            <span class="iconfont iconicon-test"></span>
        </div>
        <div class="search-con">
            <van-search
                placeholder="请输入搜索关键词"
                v-model="keywords"
                @search="search"
            ></van-search>
        </div>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                v-if="total"
            >
                <ul class="list">
                    <template v-for="(item) in materialPlanList">
                        <li
                            class="materialPlan-item"
                            :class="`status${item.status}`"
                            :key="item.poid"
                            @click="toInfo(item)"
                        >
                            <div class="engineeringInfo">
                                <h4 class="engineeringInfo_header">
                                    <span class="state corner-marker" v-if="item.status===0">未提交</span>
                                    <span class="state corner-marker" v-else-if="item.status===1">已提交</span>
                                    <span class="state corner-marker" v-else-if="item.status===2">退回</span>
                                    <span class="state corner-marker" v-else-if="item.status===3">撤销</span>
                                    <span class="state corner-marker" v-else-if="item.status===4">确认</span>
                                    <span class="state corner-marker" v-else-if="item.status===5">关闭</span>
                                    <span class="state corner-marker" v-else-if="item.status===6">完成</span>
                                    <span class="headerName">申请编号：{{ item.order_number }}</span>
                                </h4>
                                <div class="engineeringInfo_content">
                                    <p>
                                        <span class="info">工程名称：{{ item.project_name }}</span>
                                    </p>
                                    <p v-if="$store.state.versionMark == 2">
                                        <span class="info">施工单位：{{ item.sgdw_name }}</span>
                                    </p>
                                    <p>
                                        <span class="info">方量：{{ item.quantity }}方</span>
                                    </p>
                                    <p>
                                        <span class="info">标号：{{ item.strength_grade_name }} {{ item.special_require_name }}</span>
                                    </p>
                                    <p>
                                        <span class="info">坍落度：{{ item.slump }} ± {{ item.slump_name }}</span>
                                    </p>
                                    <p>
                                        <span class="info">浇筑方式：{{ item.pouring_name }}</span>
                                    </p>
                                    <p v-if="$store.state.versionMark == 2">
                                        <span class="info">施工部位：{{ item.place_detail }}</span>
                                    </p>
                                    <p>
                                        <span class="info">登记时间：{{ item.bill_time }}</span>
                                    </p>
                                    <p>
                                        <span class="info">业务员：{{ item.employee_name }}</span>
                                    </p>
                                    <p>
                                        <span class="info">到货时间：{{ item.arrival_time }}</span>
                                    </p>
                                    <span class="connect" @click.stop="toMsg(item.contract_number)">沟通</span>
                                </div>
                            </div>
                            <div class="btns-con">
                                <div class="btn" @click.stop="handleCopyNew(item)">
                                    <span class="iconfont iconfuzhi"></span>
                                    <span>复制新增</span>
                                </div>
                                <div class="btn" v-if="item.can_delete" @click.stop="deleOrder(item)">
                                    <span class="iconfont iconshanchu"></span>
                                    <span>删除</span>
                                </div>
                            </div>
                        </li>
                    </template>
                </ul>
            </van-list>
            <div class="no-data" v-if="!total"></div>
        </van-pull-refresh>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import { Dialog } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            materialPlanList: [],
            loading: false,
            finished: false,
            page: {
                pageindex: 0,
                pagesize: 2,
            },
            total: true,
            currentContractNumber: '', // 当前合同编号
            isLoading: false,
            keywords: '',
            timer: null,
        };
    },
    methods: {
        getpageUser() {
            this.$axios.get('/interfaceApi/production/productorder/getpage_user/' + this.page.pageindex + '/' + this.page.pagesize
            + '?keywords=' + this.keywords)
                .then(res => {
                    this.loading = false;
                    this.isLoading = false;
                    // this.total = false;
                    if (res.total) {
                        this.total = true;
                        this.materialPlanList = this.materialPlanList.concat(res.rows);
                        if (this.materialPlanList.length >= res.total) {
                            this.finished = true;
                        }
                    } else {
                        this.total = false;
                        this.finished = true;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 数据分页加载
        onLoad() {
            if (this.isLoading) {
                this.materialPlanList = [];
                this.isLoading = false;
            }
            if (!this.timer) {
                this.timer = setTimeout(() => {
                    this.page.pageindex++;
                    this.getpageUser();
                    this.timer = null;
                }, 0);
            }
        },
        onRefresh() {
            this.page.pageindex = 0;
            this.materialPlanList = [];
            this.finished = false;
            this.onLoad();
        },
        search() {
            this.page.pageindex = 0;
            this.materialPlanList = [];
            this.finished = false;
            this.onLoad();
        },
        // 拉取个人登记订单列表（分页）
        getList() {
            return this.$axios.get('/interfaceApi/production/productorder/getpage_user/' + this.page.pageindex + '/' + this.page.pagesize);
        },
        // 跳转到详情页
        toInfo(data) {
            // 0 未提交跳转到新建页面 其他跳转到详情页面
            if (data.status === 0 || data.status === 2) {
                this.$router.isBack = 2;
                this.$router.push({ name: 'newMaterialPlan', params: { formData: data, type: 'modifiy' } });
            } else {
                this.$router.isBack = 2;
                this.$router.push({ name: 'materialPlanInfo', params: { order_number: data.order_number, contract_number: data.contract_number } });
            }
        },
        // 新增
        newPlan() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'newMaterialPlan', params: { type: 'new' } });
        },
        // 复制新增
        async handleCopyNew(item) {
            const res = await this.getContractClose(item);
            if (!res) {
                // 获取合同数据
                const data = await this.getContractByNumber(item);
                const dataParse = JSON.parse(JSON.stringify(item));
                dataParse.status = 0;
                dataParse.poid = null;
                dataParse.special_require = '';
                dataParse.special_require_name = '';
                dataParse.pump_truck = '';
                dataParse.pump_truck_name = '';

                dataParse.station = data.supply_site;
                dataParse.station_name = data.supply_site_name;
                dataParse.employee_code = data.salesman_id;
                dataParse.employee_name = data.salesman_name;
                dataParse.employee_phone = data.salesman_phone;
                dataParse.customer_name = data.client_name;
                dataParse.customer_xydm = data.client_uscc;
                this.$router.isBack = 2;
                this.$router.push({ name: 'newMaterialPlan', params: { formData: dataParse, type: 'copyNew' } });
            } else {
                this.$toast('该合同已关闭，不能复制新增！');
            }
        },
        // 删除未提交订单
        deleOrder(data) {
            Dialog.confirm({
                message: '确认删除？',
            }).then(async () => {
                const res = await this.deleOrderApi(data);
                if (res || res === null) {
                    this.$toast('删除成功！');
                    this.materialPlanList = [];
                    this.isLoading = false;
                    this.page.pageindex = 0;
                    this.finished = false;
                    if (!this.timer) {
                        this.timer = setTimeout(() => {
                            this.page.pageindex++;
                            this.getpageUser();
                            this.timer = null;
                        }, 0);
                    }
                }
            }).catch(() => {
                // on cancel
            });

        },
        // 删除未提交订单
        deleOrderApi(data) {
            // const json = { ordernumbers: [data.order_number] };
            return this.$axios.$post('/interfaceApi/production/productorder/delete', [data.order_number]);
        },
        // 拉取合同最新数据
        getContractByNumber(data) {
            const url = '/interfaceApi/sale/contract_manager/get_contract_by_number?contractNumber=' + data.contract_number;
            return this.$axios.$get(url, { defEx: true });
        },
        // 拉取合同是否已经关闭
        getContractClose(data) {
            return this.$axios.$post('/interfaceApi/sale/contract_manager/is_contract_close_by_number/' + data.contract_number, { defEx: true });
        },
        // 拉取合同关联用户（云信群组）
        getContractUserPhone() {
            return this.$axios.$get('/interfaceApi/sale/contract_manager/get_contract_user_phone/' + this.currentContractNumber);
        },
        // 拉取用户云信Id列表
        getAccids(phones) {
            return this.$axios.$post('/interfaceApi/message/MessageNetease/get_accids', phones);
        },
        // 发起聊天
        async toMsg(contract_number) {
            this.currentContractNumber = contract_number;
            const res = await this.getContractUserPhone();
            if (res) {
                if (res.netease_group_id === null || res.netease_group_id === '') {
                    const accids = await this.getAccids(res.phones);
                    if (accids) {
                        const callMobileData = {
                            uids: accids,
                            groupName: res.group_name,
                            type: '0',
                            contractId: contract_number,
                        };
                        this.$callMobile('JYTeamsNative', 'jyCreatedGroupWithContractInfo', callMobileData);
                    } else {
                        this.$toast('当前订单暂时无法进行沟通！');
                    }
                } else {
                    const callMobileData = {
                        conversationId: res.netease_group_id,
                        name: res.group_name,
                        type: '1',
                    };
                    this.$callMobile('JYTeamsNative', 'GetConversationInfo', callMobileData);
                }
            } else {
                this.$toast('当前订单暂时无法进行沟通！');
            }
        },
        // 原生调js回传群组json
        callback_GetTeamsListInfo(chartGroupJson) {
            const groupData = JSON.parse(chartGroupJson).teams[0];
            if (groupData.teamid && groupData.teamid !== 'undefined') {
                const res = this.addContractNetease(groupData);
                if (res) {
                    this.groupChat(groupData);
                }
            }
        },
        // 合同关联云信群组
        addContractNetease(groupData) {
            return this.$axios.put('/interfaceApi/sale/contract_manager/add_contract_netease/' + groupData.contractId + '/' + groupData.teamid);
        },
        // 点群组列表进入群组聊天
        groupChat(data) {
            const callMobileData = {
                conversationId: data.teamid,
                name: data.teamName,
                type: '1',
            };
            this.$callMobile('JYTeamsNative', 'GetConversationInfo', callMobileData);
        },
    },
    created() {
        // 转发原生回调函数
        window.callback_GetTeamsListInfo = this.callback_GetTeamsListInfo;
    },
};
</script>

<style lang="stylus">
.materialPlan-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .newPlan
        position fixed
        right 20rpx
        top 10rpx
        z-index 1000
        color #fff
    .van-pull-refresh
        height 100%
        overflow-y auto
        overflow-x hidden
        .materialPlan-item
            .connect
                position absolute
                bottom 70rpx
                right 15rpx
                padding 5rpx 15rpx
                border 1px solid #5588F1
                border-radius 4rpx
                color #5588F1
            &.status0
                .corner-marker
                    background #0189FC
            &.status1
                .corner-marker
                    background #04B97F
            &.status2
                .corner-marker
                    background #E60000
            &.status3
                .corner-marker
                    background #E60000
            &.status4
                .corner-marker
                    background #FF6600
            &.status5
                .corner-marker
                    background #04A2B9
            &.status6
                .corner-marker
                    background #979EA7

</style>
<style>
    .materialPlan-box .van-list__error-text, .van-list__finished-text, .van-list__loading{
        position: relative;
        height: 50rpx;
    }
    .materialPlan-box .van-loading__spinner{
        position: relative!important;
        top: 0!important;
        left: 0!important;
        display: inline-block;
        width: 30px;
        max-width: 100%;
        height: 30px;
    }

</style>
